export const AI_CHAT = {
  CONVERSATION: "AI_CHAT_CONVERSATION",
};